import React from 'react';

import ParagraphVideoContent from './WithContent';
import ParagraphVideo from './WithoutContent';
import ParagraphVideoGetStarted from './GetStarted';

const Video = (props) => {
  const { viewMode, entity } = props;

  const content = entity.getIn(['field_title', 0, 'value']);

  if (viewMode === 'getStarted') {
    return <ParagraphVideoGetStarted {...props} />;
  }

  if (content) {
    return <ParagraphVideoContent {...props} />;
  }

  return <ParagraphVideo {...props} />;
};

export default Video;
